module.exports = __webpack_public_path__ + "img/edit-document.bdebe05c.svg";